<template>
  <div ref="group" class="eg-custom-radio-group">
    <div class="sliding-pill" :style="pillStyle" />
    <eg-custom-radio
      v-for="(option, index) in options"
      :key="option.value"
      :ref="`opt${index}`"
      :is-selected="value === option.value"
      @click="handleClick(option.value)"
    >
      {{ option.text || option.label }}
    </eg-custom-radio>
  </div>
</template>

<script>
import EgCustomRadio from "./eg_custom_radio.vue";

export default {
  name: "EgCustomRadioGroup",
  components: { EgCustomRadio },
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pill: { left: 0, width: 0 },
      pillAnimating: false,
      wasClicked: false,
    };
  },
  computed: {
    pillStyle() {
      return {
        left: `${this.pill.left}px`,
        width: `${this.pill.width}px`,
        transition: this.pillAnimating
          ? "left 0.25s cubic-bezier(0.4, 0, 0.2, 1)"
          : "none",
      };
    },
  },
  watch: {
    value() {
      const animate = this.wasClicked;
      this.wasClicked = false;
      this.movePill(animate);
    },
  },
  mounted() {
    this.$nextTick(() => this.movePill(false));
  },
  methods: {
    handleClick(val) {
      this.wasClicked = true;
      this.$emit("input", val);
    },
    movePill(animate) {
      this.$nextTick(() => {
        const idx = this.options.findIndex((o) => o.value === this.value);
        if (idx === -1) return;

        const ref = this.$refs[`opt${idx}`];
        if (!ref) return;

        const btnEl = (Array.isArray(ref) ? ref[0] : ref).$el;
        const groupEl = this.$refs.group;
        const gRect = groupEl.getBoundingClientRect();
        const bRect = btnEl.getBoundingClientRect();

        this.pillAnimating = animate;
        this.pill = {
          left: bRect.left - gRect.left,
          width: bRect.width,
        };
      });
    },
  },
};
</script>

<style scoped lang="scss">
.eg-custom-radio-group {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 28px;
  padding: 4px;
  position: relative;

  ::v-deep .eg-new-button {
    position: relative;
    z-index: 1;

    &.eg-new-button--secondary {
      background-color: transparent;
      border-color: transparent;
      color: white;
      border-radius: 24px;
      padding: 6px 12px;

      &:hover {
        background-color: rgba(255, 255, 255, 0.15);
        color: white;
        border-color: transparent;
      }
    }

    &.eg-new-button--primary {
      background-color: transparent;
      color: #6a50f3;
      border-radius: 24px;
      padding: 6px 12px;
      border-color: transparent;
      line-height: 12px;

      &:hover {
        background-color: transparent;
        border-color: transparent;
        color: #6a50f3;
      }
    }
  }
}

.sliding-pill {
  position: absolute;
  top: 4px;
  bottom: 4px;
  background: white;
  border-radius: 24px;
  z-index: 0;
  pointer-events: none;
  transition-property: left;
}
</style>
